<div class="full-signup d-flex align-items-stretch">
  <div class="signup-col">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 form-col">
          <!-- Signup -->
          <div class="d-flex justify-content-between align-items-center">
            <img class="buk-logo" src="/assets/logo-a.png" alt="" />
            <a class="text-secondary" routerLink="/logout">{{ 'SHARED.signup2.logout' | translate }}</a>
          </div>
          <h3 class="mb-2">{{ 'SHARED.signup2.registerBusinessTitle' | translate }}</h3>
          <p class="mb-4">{{ 'SHARED.signup2.registerBusinessSubtitle' | translate }} {{currentUser?.firstName}} 👋</p>

          <div *ngIf="loadingGoogle">
            <div class="d-flex justify-content-center align-items-center">
              <app-loader></app-loader>
            </div>
          </div>
          <div *ngIf="!loadingGoogle">
            <div *ngIf="currentStep === 1">
              <div class="form-group">
                <label>{{ 'CREATE_MERCHANT.googleQuestion' | translate }}</label>
                <app-google-places-input adressType="establishment" [fields]="['name', 'international_phone_number', 'address_components', 'place_id']" (clearAddress)="this.extraData = null" (setAddress)="handleGooglePlace($event)" />
                <label class="mt-2">{{ 'CREATE_MERCHANT.googleNotes' | translate }}</label>
              </div>
              <div class="d-flex w-100 justify-content-between mt-3">
                <button class="btn btn-secondary btn-md" (click)="currentStep = 2">{{ 'CREATE_MERCHANT.skipStep' | translate }}</button>
                <button class="btn btn-primary btn-md" [class.disabled]="!extraData" (click)="confirmGoogle()">{{ 'CREATE_MERCHANT.confirm' | translate }}</button>
              </div>
            </div>
  
            <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form && currentStep === 2">
              <p *ngIf="form.get('email')" class="missing-email">{{ 'SHARED.signup.missingEmail' | translate }}:</p>
  
              <div *ngIf="form.get('email')" class="mb-3">
                <app-text-input
                  inputClasses=""
                  formControlName="email"
                  [submitAttempted]="submitAttempted"
                  placeholder="{{ 'GENERAL.email' | translate }}"
                  inputType="email"
                  invalidMsg="{{ 'SHARED.signup.writeYourEmail' | translate }}"
                  class="mb-2"
                ></app-text-input>
              </div>
  
              <p *ngIf="form.get('email')" class="missing-email">{{ 'SHARED.signup.aboutBusiness' | translate }}:</p>
  
              <app-text-input
                inputClasses=""
                formControlName="merchantName"
                [submitAttempted]="submitAttempted"
                placeholder="{{ 'SHARED.setupMerchantPage.businessName' | translate }}"
                inputType="text"
                invalidMsg="{{ 'SHARED.setupMerchantPage.invalidBusinessName' | translate }}"
              ></app-text-input>
  
              <div class="form-group">
                <app-dropdown-input
                  *ngIf="showCountrySelector"
                  formControlName="country"
                  [options]="countries"
                  [submitAttempted]="submitAttempted"
                  placeholder="{{ 'SHARED.setupMerchantPage.chooseCountry' | translate }}"
                  [invalidMsg]="null"
                ></app-dropdown-input>
              </div>
  
              <div class="form-group">
                <app-phone-input controlName="phone" [form]="form" [submitAttempted]="submitAttempted"/>
                <div class="invalid-feedback" *ngIf="submitAttempted && !form.get('phone').valid">
                  {{ 'SHARED.signup.writeYourPhone' | translate }}
                </div>
              </div>
  
              <div class="mb-3 mt-3">
                <!-- newCompanyCampaignCheck -->
                <div class="custom-control custom-checkbox mb-3 terms">
                  <p class="mb-2 text-bold color-primary">
                    {{ 'SHARED.signup.newCompaniesCampaingCheckboxTitle' | translate }}
                  </p>
                  <p class="mb-3">
                    {{ 'SHARED.signup.newCompaniesCampaingDesc' | translate }}
                  </p>
                  <input formControlName="newCompanyCampaign" type="checkbox" class="custom-control-input" id="newCompanyCampaignCheck" />
                  <label
                    class="custom-control-label mb-2"
                    for="newCompanyCampaignCheck"
                    [ngClass]="{ 'is-invalid': (submitAttempted || submitSocialAttempted) && !form.get('newCompanyCampaign').valid }">
                  {{ 'SHARED.signup.newCompaniesCampaingCheckbox' | translate }}
                  </label>
                </div>
  
                <!-- terms -->
                <div class="custom-control custom-checkbox mb-4 terms">
                  <input formControlName="terms" type="checkbox" class="custom-control-input" id="customCheck1" />
                  <label
                    class="custom-control-label"
                    for="customCheck1"
                    [ngClass]="{ 'is-invalid': (submitAttempted || submitSocialAttempted) && !form.get('terms').valid }"
                  >
                    {{ 'SHARED.signup.readTerms1' | translate }}
                    <a rel="canonical" routerLink="/terms">{{ 'SHARED.signup.readTerms2' | translate }}</a> {{ 'SHARED.signup.readTerms3' | translate }}
                    <a rel="canonical" routerLink="/privacy">{{ 'SHARED.signup.readTerms4' | translate }}</a
                    >.
                  </label>
                  <div class="invalid-feedback" *ngIf="(submitAttempted || submitSocialAttempted) && !form.get('terms').valid">
                    {{ 'GENERAL.requiredField' | translate }}
                  </div>
                </div>
                <!-- error -->
                <app-alert [msg]="errorMsg" type="danger"></app-alert>
                <!-- submit -->
                <app-submit-btn
                  inputClasses="w100 btn-lg"
                  [loading]="loading"
                  [hasError]="errorMsg"
                  btnCopy="{{ 'GENERAL.continue' | translate }}"
                ></app-submit-btn>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="signup-col bg-img d-flex align-items-bottom">
    <div class="testimonial d-flex align-items-center">
      <div>
        <div class="test-content d-flex align-items-top">
          <div class="avatar"></div>
          <div class="quote">
            <h4>
              {{ 'SIGNUP.testimonial.quote' | translate }}
            </h4>
            <p class="name">{{ 'SIGNUP.testimonial.author' | translate }}</p>
          </div>
        </div>

        <div class="list-benefits">
          <div class="row" data-nosnippet>
            <div class="col-12">
              <h3>{{ 'SIGNUP.testimonial.benefitsTitle' | translate }}</h3>
            </div>
            <div class="col-md-6">
              <p class="d-flex align-items-center">
                <i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.0' | translate }}
              </p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.1' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.2' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.3' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.4' | translate }}</p>
            </div>
            <div class="col-md-6">
              <p><i class="material-icons icon">check</i> {{ 'SIGNUP.testimonial.benefitsList.5' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
